// native
import { Component, EventEmitter, Input, Output } from '@angular/core';

// models
import { PageChangeEvent } from 'app/models';

/** Kendo-style pager: nav arrows, numbered page buttons, and an item range label. */
@Component({
    selector: 'app-grid-pager',
    templateUrl: './grid-pager.component.html',
    standalone: false
})
export class GridPagerComponent {
  @Input() total = 0;
  @Input() skip = 0;
  @Input() pageSize = 1;
  /** Max number of numbered page buttons shown at once. */
  @Input() buttonCount = 10;

  @Output() pageChange = new EventEmitter<PageChangeEvent>();

  get totalPages(): number {
    return this.pageSize > 0 ? Math.ceil(this.total / this.pageSize) : 0;
  }

  get page(): number {
    return this.pageSize > 0 ? Math.floor(this.skip / this.pageSize) : 0;
  }

  get rangeStart(): number {
    return this.total === 0 ? 0 : this.skip + 1;
  }

  get rangeEnd(): number {
    return Math.min(this.skip + this.pageSize, this.total);
  }

  get pages(): number[] {
    const totalPages = this.totalPages;
    if (totalPages <= 0) {
      return [];
    }
    const half = Math.floor(this.buttonCount / 2);
    let start = Math.max(0, this.page - half);
    const end = Math.min(totalPages - 1, start + this.buttonCount - 1);
    start = Math.max(0, end - this.buttonCount + 1);

    const result: number[] = [];
    for (let i = start; i <= end; i++) {
      result.push(i);
    }
    return result;
  }

  get isFirst(): boolean {
    return this.page <= 0;
  }

  get isLast(): boolean {
    return this.page >= this.totalPages - 1;
  }

  goTo(page: number): void {
    const clamped = Math.max(0, Math.min(page, this.totalPages - 1));
    if (clamped === this.page || this.totalPages <= 0) {
      return;
    }
    this.pageChange.emit({ skip: clamped * this.pageSize, take: this.pageSize });
  }
}
